import skeleton from '../../../components/skeleton';
import vueSeamlessScroll from "vue-seamless-scroll";
import version from "../../../components/version";
import pay from "../../../components/pay";
import QRCode from "../../../components/QRCode";
import './payOverview.less'
export default {
    name: "payOverview",
    data() {
        return {
            top: {
                title: '适合您业务发展的<br/>全系列支付商品',
                txtPc: '由于每个业务所属的行业不同、所处的发展阶段不同，联拓数科提供了各种不同的支付产品与服务，<br/>可帮助您快速打通线下支付，连接线上运营，更好地经营自己的生意。<br/>无论您希望继续使用原有收银软件，或是希望更换收银软件，<br/>或是使用更轻巧的小设备方案，您都可以找到更适合您的联拓产品。',
                txtWap: '由于每个业务所属的行业不同、所处的发展阶段不同，联拓数科提供了各种不同的支付产品与服务，可帮助您快速打通线下支付，连接线上运营，更好地经营自己的生意。<br/>无论您希望继续使用原有收银软件，或是希望更换收银软件，或是使用更轻巧的小设备方案，您都可以找到更适合您的联拓产品。'
            },
            title1: '亮点能力',
            tip1Pc: '联拓数科的所有支付产品具备更有竞争力的亮点功能<br/>更加适合快速发展中的线下商家，不论是单店还是连锁。',
            tip1Wap: '联拓数科的所有支付产品具备更有竞争力的亮点功能更加适合快速发展中的线下商家，不论是单店还是连锁。',
            pic1: 'img/payOverview/pic1.png',
            title2: '支付，不止于支付',
            tip2: '更多解决方案',
            pic2: 'img/payOverview/pic2.png',
            info: [
                {
                    pic: 'img/payOverview/info1.png',
                    title: '支付超市',
                    tip: '一站式的移动支付解决方案',
                    txt: '支付超市是联拓数科面向支付机构、软件厂商、集团性连锁、银行等客户推出的一站式移动支付解决方案，让客户能够轻松构建自己的商业支付平台。',
                    block: '',
                    color: '#f4f4f4',
                    linkType: 'router',
                    linkTxt: '了解更多开放平台解决方案',
                    linkHref: '/productHighlights',
                    list: [
                        '只需要简单配置，即可让您接入不同业务所需要的通道，包括微信、支付宝、银行、银联、三方、四方、等不同类型的通道。',
                        '即刻享受联拓数科的丰富、稳定的收银端的能力，包括插件、软件、硬件等。',
                        '我们拥有强大的代理商管理系统，也一并输出给您，可以在报表、分账、返佣、数据等环节全程无忧。',
                        '联拓数科十几年的高交易金额的系统打磨，使得这个平台具备高稳定性，同时，我们也可以开放接受OEM业务。'
                    ]
                },
                {
                    pic: 'img/payOverview/info2.png',
                    title: '连锁业务中台',
                    tip: '一站式的连锁平台解决方案',
                    txt: '连锁业务中台是联拓数科面向连锁加盟企业推出的一站式门店数字化SaaS系统解决方案，让客户能够高效地运营自己的私域流量和管理多家直营或加盟门店。',
                    block: 'swap',
                    color: '#000',
                    linkType: 'router',
                    linkTxt: '了解更多',
                    linkHref: '/productHighlights',
                    list: [
                        '加盟门店快速统一收银与支付。',
                        '总部后台统一管理会员和数据。',
                        '建设和运营属于品牌总部自己的私域流量，打造自己的数字化平台。',
                        '建立门店钱包，高效管理门店。'
                    ]
                },
                {
                    pic: 'img/payOverview/info3.png',
                    title: '预授权支付',
                    tip: '',
                    txt: '联拓数科的预授权支付是连接了微信、支付宝的预授权移动支付能力，为酒店、租车、自助餐厅等需要押金支付场景的商户提供顾客资金冻结，结算时从冻结资金划扣给商户，剩余资金解冻返还给顾客的产品能力。',
                    block: '/caseHotel',
                    color: '#fff',
                    linkType: 'router',
                    linkTxt: '了解更多',
                    linkHref: '',
                    list: [
                        '用户无需现金、纸张等记录方式，聚合微信与支付宝的移动支付能力。',
                        '具备便利的商户后台结算方式。',
                        '即使商户没有设备，也可以直接下载app享受押金支付方式。'
                    ]
                }
            ],
            rollList: [
                {
                    src: "/img/payOverview/logo1.png",
                    size: 1,
                },
                {
                    src: "/img/payOverview/logo2.png",
                    size: 1,
                },
                // {
                //     src: "/img/payOverview/logo3.png",
                //     size: 1,
                // },
                // {
                //     src: "/img/payOverview/logo4.png",
                //     size: 1,
                // },
                // {
                //     src: "/img/payOverview/logo5.png",
                //     size: 1,
                // },
                // {
                //     src: "/img/payOverview/logo6.png",
                //     size: 1,
                // },
                {
                    src: "/img/payOverview/logo7.png",
                    size: 1,
                },
                // {
                //     src: "/img/payOverview/logo8.png",
                //     size: 1,
                // },
                {
                    src: "/img/payOverview/logo9.png",
                    size: 1,
                },
                // {
                //     src: "/img/payOverview/logo10.png",
                //     size: 1,
                // },
                {
                    src: "/img/payOverview/logo11.png",
                    size: 1,
                },
                {
                    src: "/img/payOverview/logo12.png",
                    size: 1,
                },
                {
                    src: "/img/payOverview/logo13.png",
                    size: 1,
                },
                {
                    src: "/img/payOverview/logo14.png",
                    size: 1,
                },
                {
                    src: "/img/payOverview/logo15.png",
                    size: 1,
                },
                // {
                //     src: "/img/payOverview/logo16.png",
                //     size: 1,
                // },
                {
                    src: "/img/payOverview/logo17.png",
                    size: 1,
                },
                // {
                //     src: "/img/payOverview/logo18.png",
                //     size: 1,
                // }
            ],
            card: [
                {
                    flip: false,
                    title: '收款小精灵',
                    txt: '无需更换原有收银设备及软件，也无需改变收银员的使用习惯，只需要安装一个软件，就可以用原有的码枪和打印机轻松实现移动收款。收款小精灵可以自动抓取收款金额，后台可设置多门店、多款台、多收银员的模式，轻松对帐。',
                    pic: 'img/payOverview/card1.png',
                    list: [
                        {
                            title: '简单高效',
                            txt: '无缝打通收银系统，无需培训，容易上手，自动收款，轻松对账'
                        },
                        {
                            title: '兼容性强',
                            txt: '兼容市面99%的收银系统'
                        },
                        {
                            title: '安全可靠',
                            txt: '底层语言编写，安全对接模式，前后台权限分离，精确控制每个收银台权限'
                        },
                        {
                            title: '高扩展性',
                            txt: '无缝接通小精灵卡券营销和小程序线上产品能力，即刻开始线上化运营'
                        },
                        {
                            title: '维护便捷',
                            txt: '后台OTA远程升级，无需安排售后人员到达现场即可轻松实现维护与升级'
                        },
                        {
                            title: '运行稳定',
                            txt: '每日订单量数百万级 产品相当稳定，数万商家的一致选择'
                        }
                    ]
                },
                {
                    flip: false,
                    title: '小精灵收银软件',
                    txt: '适合于中、大型零售商超的本地化部署的收银软件。完美实现了收银与会员的一体化，门店管理和线上商城的一体化。',
                    pic: 'img/payOverview/card7.png',
                    list: [
                        {
                            title: '适合：中、大型零售商超',
                            txt: ''
                        },
                        {
                            title: 'C/S收银，本地部署，稳定抗压',
                            txt: ''
                        },
                        {
                            title: '收银&会员全面一体化',
                            txt: ''
                        },
                        {
                            title: '线上商城&线下生意一体化',
                            txt: ''
                        },
                        {
                            title: '独立版老板助手APP，移动管店',
                            txt: ''
                        }
                    ]
                },
                {
                    flip: false,
                    title: '小精灵零售SaaS',
                    txt: '适合于中、小型零售便利超市，是会营销的互联网收银台。是集移动聚合支付、前端收银、微信会员、O2O商城、线上推广营销、企业订单管理系统、线上采购、资金管理等功能的智能收银管理系统。',
                    pic: 'img/payOverview/card3.png',
                    list: [
                        {
                            title: '适合：中、小型零售便利店',
                            txt: ''
                        },
                        {
                            title: '云端部署，实施便捷',
                            txt: ''
                        },
                        {
                            title: '收银&会员全面一体化',
                            txt: ''
                        },
                        {
                            title: '线上商城&线下生意一体化',
                            txt: ''
                        }
                    ]
                },
                {
                    flip: false,
                    title: '小精灵餐饮SaaS',
                    txt: '适合于中、小型快餐、烘焙、熟食、茶饮类型商家的收银软件。同时集门店收银、会员营销、外卖管理、扫码点餐于一体的轻量化数字收银系统。',
                    pic: 'img/payOverview/card9.png',
                    list: [
                        {
                            title: '造合:中.小型餐饮商户',
                            txt: ''
                        },
                        {
                            title: '10分钟完成安装,快速上手',
                            txt: ''
                        },
                        {
                            title: '收银&会员一体,高效收银',
                            txt: ''
                        },
                        {
                            title: '一线上&线下一体,轻松管店',
                            txt: ''
                        },
                        {
                            title: '扫码点餐&外卖管理一体',
                            txt: ''
                        }
                    ]
                },
                {
                    flip: false,
                    title: '数字前台',
                    txt: '无需做任何开发，即可将自助收银机、外卖、自提、扫码点餐、扫码购、小程序商城等新零售业务与商户原有ERP系统打通，让商家原有系统的订单、库存、商品、账单与在线业务无缝衔接，减少商家对账成本，节省系统开发成本，提升商户运营效率，快速上线新零售业务。',
                    pic: 'img/payOverview/card2.png',
                    list: [
                        {
                            title: '零成本升级（零售通、京东收银）',
                            txt: ''
                        },
                        {
                            title: '永久防查杀，守护支付返佣',
                            txt: ''
                        },
                        {
                            title: '三种会员打通的模式',
                            txt: ''
                        },
                        {
                            title: '多种门店类型通用',
                            txt: ''
                        },
                        {
                            title: '兼容生鲜码',
                            txt: ''
                        },
                        {
                            title: '兼容多种外设',
                            txt: ''
                        },
                        {
                            title: '支持离线收银',
                            txt: ''
                        },
                        {
                            title: '会员卡券打通',
                            txt: ''
                        },
                        {
                            title: '商城外卖打通（减库存，自动记账）',
                            txt: ''
                        },
                        {
                            title: '自助机打通',
                            txt: ''
                        }
                    ]
                },
                {
                    flip: false,
                    title: '小精灵PRO版软件',
                    txt: '严格挑选细分行业优秀软件，构建软件矩阵，深度打通小精灵移动支付、卡券营销、企业钱包能力，输出对应软件的小精灵PRO版本，为小精灵3000家服务商提供深度赋能的数字商业服务市场，打造一站式的数字商业服务平台，助力线下商家数字化，让实体经济高质量发展',
                    pic: 'img/payOverview/card4.png',
                    list: [
                        {
                            title: '菜麽麽',
                            txt: ''
                        },
                        {
                            title: '千帆掌柜',
                            txt: ''
                        },
                        {
                            title: '致远方象',
                            txt: ''
                        },
                        {
                            title: '银豹',
                            txt: ''
                        },
                        {
                            title: '硕天',
                            txt: ''
                        },
                        {
                            title: '朋科',
                            txt: ''
                        },
                        {
                            title: '爱宝',
                            txt: ''
                        }
                    ]
                },
                {
                    flip: false,
                    title: '手持收款设备',
                    txt: '集支付、会员收款、优惠券核销功能于一体的轻便高效的手持收款设备，适合高档餐厅、西餐、加油站等高额行业。',
                    pic: 'img/payOverview/card10.png',
                    list: [
                        {
                            title: '适合：中大型商户，尤其是泛行业商户',
                            txt: ''
                        },
                        {
                            title: '收银、核销、出票、播报一体',
                            txt: ''
                        },
                        {
                            title: '微信、支付宝、刷卡、会员支付一体',
                            txt: ''
                        },
                        {
                            title: '移动在线门店管理、会员管理、员工管理、财务对账',
                            txt: ''
                        }
                    ]
                },
                {
                    flip: false,
                    title: '刷脸设备',
                    txt: '集IC卡刷卡、微信支付、支付宝支付、刷脸支付、会员支付于一体的智能刷脸设备，适合校园、团餐等场景的商户。',
                    pic: 'img/payOverview/card11.png',
                    list: [
                        {
                            title: '适合：校园食堂、团餐食堂',
                            txt: ''
                        },
                        {
                            title: '刷脸、微信、支付宝、NFC卡刷卡一体',
                            txt: ''
                        },
                        {
                            title: '双屏显示，商家和客户可清楚看见消费信息，避免出错',
                            txt: ''
                        },
                        {
                            title: '内置大功率喇叭，嘈杂环境也能清晰听见语音播报',
                            txt: ''
                        }
                    ]
                },
                {
                    flip: false,
                    title: '码牌设备',
                    txt: '联拓的收银软件和插件已完美适配和多种不同场景、不同业务的硬件，便于商家轻松使用、快速收银。',
                    pic: 'img/payOverview/card5.png',
                    list: [
                        {
                            title: '小精灵码牌',
                            txt: ''
                        },
                        {
                            title: '小精灵语音王',
                            txt: ''
                        },
                        {
                            title: '小精灵收款王',
                            txt: ''
                        }
                    ]
                },
                {
                    flip: false,
                    title: '小精灵商户通',
                    txt: '小精灵商户通APP是我们对商家量身打造的一款移动应用客户端。提供“支付+营销”一体化的智慧新零售移动工具，可以从多角度，多方位帮助商家实现精准营销，提升客单价。',
                    pic: 'img/payOverview/card6.png',
                    list: [
                        {
                            title: '一站式满足您的移动支付收款需求',
                            txt: ''
                        },
                        {
                            title: '强大的店铺会员营销工具',
                            txt: ''
                        },
                        {
                            title: '具备线上化业务管理能力，包括外卖、商城、点单小程序',
                            txt: ''
                        }
                    ]
                }
            ],
            ability: [
                {
                    pic: 'img/payOverview/ability1.png',
                    txt: '轻松聚合各种支付方式，已对接50+条支付通道，可以享受各种优惠政策'
                },
                {
                    pic: 'img/payOverview/ability2.png',
                    txt: '整合了线下经营所必须的各种营销工具，打通会员/商城/外卖，即刻开始数字化'
                },
                {
                    pic: 'img/payOverview/ability3.png',
                    txt: '为不同业态/规模的商户提供各种“支付端”的解决方案，从独立设备到收银系统，都有解决方案'
                },
                {
                    pic: 'img/payOverview/ability4.png',
                    txt: '支付产品的所有能力也支持与不同系统的API快速对接，便于机构与企业能够低成本获得新零售能力'
                }
            ],
            dot: [
                {
                    title: '插件或收银软件',
                    state: false
                },
                {
                    title: '线上商城与外卖',
                    state: false
                },
                {
                    title: '数据与分析',
                    state: false
                },
                {
                    title: '卡券营销',
                    state: false
                },
                {
                    title: '各种硬件保证收款',
                    state: false
                },
                {
                    title: '会员营销',
                    state: false
                },
                {
                    title: '会员标签与精准营销',
                    state: false
                }
            ]
        }
    },
    components: {
        skeleton,
		version,
        pay,
        QRCode,
        vueSeamlessScroll
    },
    computed: {
        classOption() {
            return {
                step: 0.7, // 数值越大速度滚动越快
                limitMoveNum: 2, // 开始无缝滚动的数据量 this.dataList.length
                hoverStop: false, // 是否开启鼠标悬停stop
                direction: 2, // 0向下 1向上 2向左 3向右
                openWatch: true, // 开启数据实时监控刷新dom
                singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
                singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
                waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
            };
        },
    },
    methods: {
        flipChange(index){
            let _this = this;
            if(_this.card[index].flip === false){
                _this.card[index].flip = true;
            }else{
                _this.card[index].flip = false;
            }
        },
        bannerOver(e) {
            this.dot[e].state = true;
        },
        bannerOut(e) {
            this.dot[e].state = false;
        },
    }
}
